<template>
  <div class="pay_cont_tail">
    <div class="payment-item-a-info-btn">
      <div class="payment-item-a-info-txts">
        <span class="tax_txt">
          현금영수증
        </span>
        <div class="tax_txt_tail">
          {{ receiptNumber }}
        </div>
      </div>
      <a
        class="bt-akl-white mini st2"
        @click="displayModal = true"
      >
        현금영수증 신청
      </a>
    </div>

    <popup-cash-receipt
      :display-modal="displayModal"
      :cash-receipt="cashReceipt"
      @close-modal="displayModal = false"
      @update-receipt-info="updateReceiptInfo"
    />

  </div>
</template>

<script>
import PopupCashReceipt from "@/views/order/main/components/PopUpWrappers/PopupCashReceipt";

export default {
  name: "PaymentReceipt",
  data() {
    return {
      displayModal: false,
      receiptNumber: this.cashReceipt.regTypeNum || '',
    }
  },
  components: {
    PopupCashReceipt,
  },
  methods: {
    updateReceiptInfo(event) {
      this.receiptNumber = event.regTypeNum;
      this.$emit('update-receipt-info', event);
    }
  },
  props: {
    cashReceipt: {
      type: Object,
      required: true,
    }
  }
}
</script>

<style scoped>

</style>
